module.exports = __webpack_public_path__ + "static/media/document-new.98a9f319.svg";